import Axios from "axios";
import { BASE } from './../services/config'

const instance = Axios.create({
  baseURL: BASE,
  timeout: 0,
  headers: {
    accept: "application/json",
    "content-type": "application/json",
  },
});

export default instance;
